export default class UserConsent {
    constructor(el, opts) {
        this.$root = $(el);
        this.$root.attr("data-consent-inited", true);

        const defaults = {
            ajax: this.$root.attr("data-consent-ajax") || "/local/ajax/userConsent.php",
            id: this.$root.attr("data-consent-id") || "2",
            url: this.$root.attr("data-consent-url") || window.location.href.split("?")[0],
            param: this.$root.attr("data-consent-param") || ""
        };
        this.options = Object.assign({}, defaults, opts);

        this.init();
    }

    init() {
        this.$root.on("change.userConsent", this._onUserConsentChange.bind(this));
    }
        
    _onUserConsentChange(e) {
        let checkbox = e.currentTarget;
        if ($(checkbox).prop("checked")) {
            $.ajax({
                type: "POST",
                url: this.options.ajax + this.options.param, 
                dataType: "json",
                data: {
                    ID: this.options.id,
                    URL: this.options.url,
                    sessid: BX.bitrix_sessid()
                },
                success: (res) => {
                    if (res.success) {
                        $(checkbox).off("change.userConsent");
                    }
                }
            });
        }
    }
}